// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Store$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Store/Store.bs.js";
import * as Product$Showside from "./Product.bs.js";
import * as DeccoUtils$Showside from "../utils/DeccoUtils.bs.js";
var empty_products = [];
var empty_page = {
  previous: undefined,
  next: undefined,
  offset: undefined,
  limit: undefined
};
var empty = {
  products: empty_products,
  page: empty_page,
  filters: undefined,
  availableSorts: undefined,
  defaultSortOrder: undefined,
  total: undefined,
  syncStatus: undefined
};
function fromJson(appliedFilters, hideOutOfStock, categoryId, storeId, json) {
  var page = DeccoUtils$Showside.decode(json, Store$ApiTypes.Products.Page2.fromJson);
  if (page.TAG !== /* Ok */0) {
    return {
      TAG: /* Error */1,
      _0: page._0
    };
  }
  var page$1 = page._0;
  var products = Belt_Array.keepMap(Belt_Array.map(page$1.products, function (__x) {
    return Product$Showside.tryParseFromDTO(appliedFilters, hideOutOfStock, categoryId, storeId, __x);
  }), function (a) {
    return a;
  });
  return {
    TAG: /* Ok */0,
    _0: {
      products: products,
      page: page$1.page,
      filters: page$1.filters,
      availableSorts: page$1.availableSorts,
      defaultSortOrder: page$1.defaultSortOrder,
      total: page$1.total,
      syncStatus: page$1.syncStatus
    }
  };
}
function makeVirtualPages(products) {
  return [{
    products: products,
    page: {
      previous: undefined,
      next: undefined,
      offset: undefined,
      limit: undefined
    },
    filters: undefined,
    availableSorts: undefined,
    defaultSortOrder: undefined,
    total: products.length,
    syncStatus: undefined
  }];
}
var Page = {
  empty: empty,
  fromJson: fromJson,
  makeVirtualPages: makeVirtualPages
};
function fromJson$1(hideOutOfStock, categoryId, storeId, json) {
  var products = DeccoUtils$Showside.decode(json, Store$ApiTypes.Products.fromJson);
  if (products.TAG === /* Ok */0) {
    return {
      TAG: /* Ok */0,
      _0: Belt_Array.keepMap(Belt_Array.map(products._0, function (product) {
        return Product$Showside.tryParseFromDTO(undefined, hideOutOfStock, categoryId, storeId, product);
      }), function (a) {
        return a;
      })
    };
  } else {
    return {
      TAG: /* Error */1,
      _0: products._0
    };
  }
}
var $$Array = {
  fromJson: fromJson$1
};
function fromJson$2(hideOutOfStock, categoryId, storeId, json) {
  var product = DeccoUtils$Showside.decode(json, Store$ApiTypes.Product.fromJson);
  if (product.TAG === /* Ok */0) {
    return Belt_Option.mapWithDefault(Product$Showside.tryParseFromDTO(undefined, hideOutOfStock, categoryId, storeId, product._0), {
      TAG: /* Error */1,
      _0: "Don't know how to parse this product"
    }, function (product) {
      return {
        TAG: /* Ok */0,
        _0: product
      };
    });
  } else {
    return {
      TAG: /* Error */1,
      _0: product._0
    };
  }
}
export { Page, $$Array, fromJson$2 as fromJson };
/* Store-ApiTypes Not a pure module */